import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    shareholderEmails: [],
    shareholderEmail: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      type: '',
      isSubscribe: '',
    },
    typeOptions: [
      { value: 1, text: '一般股東' },
      { value: 2, text: '投信' },
      { value: 3, text: '證券' },
      { value: 4, text: '自營商' },
      { value: 5, text: '銀行' },
      { value: 6, text: '壽險' },
      { value: 7, text: '分析師' },
      { value: 8, text: '經理人' },
      { value: 9, text: '銷售員' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.shareholderEmails = [];
      state.shareholderEmail = null;
    },
    SET_SHAREHOLDER_EMAILS(state, data) {
      state.shareholderEmails = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SHAREHOLDER_EMAIL(state, data) {
      state.shareholderEmail = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setShareholderEmail({ commit }, data) {
      commit('SET_SHAREHOLDER_EMAIL', data);
    },

    find({ commit, state }) {
      let url = `/shareholder_emails?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SHAREHOLDER_EMAILS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/shareholder_emails/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_SHAREHOLDER_EMAIL', item);
        });
    },

    destroy(_, id) {
      return http(`/shareholder_emails/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/shareholder_emails/${id}`, { method: 'PUT', data })
        : http('/shareholder_emails', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    toggleSubscribe(_, id) {
      return http(`/shareholder_emails/${id}/subscribe`, { method: 'PUT' })
        .then((response) => response.body);
    },
  },
};
